import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Banner, Card, Form } from '@shopify/polaris';
import PolarisFormProvider from '@container/PolarisFormProvider';

import SectionForm from '@presentational/section/SectionForm';
import FormPageActions from '@container/FormPageActions';
import BannerFormModal from '@presentational/section/BannerFormModal';
import BannerListForm from 'components/presentational/section/BannerListForm';

import { recursiveWriteFormForRecords, writeSimpleFieldsOnFormData } from 'utils';
import { SectionSchema } from 'utils/validationSchemas';

import { Map, List } from 'immutable'
import { render } from 'react-dom';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  destroyURL: PropTypes.string,
  record: PropTypes.object,
  fetchCollectionURL: PropTypes.string.isRequired,
  fetchProductURL: PropTypes.string.isRequired,
  collectionBaseURL: PropTypes.string.isRequired,
  method: PropTypes.string, // HTML form method
}

const defaultProps = {

}

const modalActions = { create: "CREATE", update: "UPDATE" };
const defaultBanner = {
  title: "", url: "",  shopify_resource_id: null, index: null, alt: "", url_web: "", b2b_url: "", b2b_alt: "",
}

const SectionBannersForm = (props) => {
  const { record } = props;
  const [open, setOpen] = useState(false);
  const [actionInfo, setActionInfo] = useState({
    banner: defaultBanner,
    action: modalActions.create,
  })

  const openModalForm = (action, banner = null) => {
    if(action == modalActions.update){
      setActionInfo({ ...actionInfo, banner: banner, action: modalActions.update, })
    }
    else{ // create
      setActionInfo({ ...actionInfo, banner: { ...defaultBanner }, action: modalActions.create, })
    }
    setOpen(true);
  }

  const closeBannerModal = () => {
    setOpen(false);
    setActionInfo({ ...actionInfo, banner: defaultBanner, name: "", })
  }

  const handleBannerRemove = (banner, renderProps) => {
    const currentBanners = List(renderProps.values.banners); // array
    const newBanners = currentBanners.set(banner.index, { ...banner, _destroy: true }).toJS(); // update on index and add _destroy flag for rails
    renderProps.setFieldValue("banners", newBanners);
  }

  const handleBannerSave = (values, renderProps) => {
    const currentBanners = renderProps.values.banners || []; // array
    if(actionInfo.action == modalActions.update){ // find link and update
      const currentBannerList = List(currentBanners);
      const newBanners = currentBannerList.set(actionInfo.banner.index, values).toJS(); // update on index (provided from callback) the new values from modal
      renderProps.setFieldValue("banners", newBanners);
      closeBannerModal();
    }
    else{ // insert new link
      const newBanners = [...currentBanners, values ];
      renderProps.setFieldValue("banners", newBanners);
      closeBannerModal();
    }
  }

  // Translate attributes and insert images
  const buildValuesForSubmit = (values, formikBag) => {
    let formData = new FormData();
    formData.append("section[title]", "");// to validate if everything is empty
    writeSimpleFieldsOnFormData(formData, "section", values)
    if(values.banners){
      recursiveWriteFormForRecords(formData, "section[banners_attributes]", values.banners, null, 
        { "image_desktop_upload": "image_desktop", "image_mobile_upload": "image_mobile", "b2b_image_desktop_upload": "b2b_image_desktop", "b2b_image_mobile_upload": "b2b_image_mobile" }
      ); // Translate banners into banners_attribute
    }

    return formData;
  }

  // When GQL gets implemented instead, they can be part of input with a more complex autosearch component
  const collectionUrlWithCountry = `${props.fetchCollectionURL}?country=${record.country}`;
  const productUrlWithCountry = `${props.fetchProductURL}?country=${record.country}`;
  const collectionBaseUrl = record.country == 'gt' ? '/collections' : props.collectionBaseURL; // Guatemala use relative URL instead!

  return (
    <PolarisFormProvider
      title={ I18n.t("activerecord.models.section.one") }
      defaultValues={ record }
      submitURL={ props.submitURL }
      submitMethod={  props.method || "POST" }
      pickValuesCallback={ buildValuesForSubmit }
      pageProps={{
        breadcrumbs: [{content: I18n.t("actions.back"), url: '/sections?resource=banners'}]
      }}
      validationSchema={ SectionSchema }
    >
      { (renderProps) => 
        <div>
          {/* { console.log("Record", props.record) } */}
          {/* { console.log("Overall form", renderProps.values) } */}
          <Card sectioned>
            <SectionForm 
              errors={ renderProps.errors } 
              values={ renderProps.values } 
              handleChange={ renderProps.handleChange } 
              kind="banners"
            />
          </Card>

          <Card title={ I18n.t("activerecord.models.banner.other") }>
            <BannerListForm 
              items={ renderProps.values.banners || [] }
              handleModalAction={ openModalForm }
              handleRemove={ (banner) => handleBannerRemove(banner, renderProps) }
            />
          </Card>

          {/* TODO when useFormik gets available PolarisFormProvider can become something more flexible. */}
          <BannerFormModal
            open={ open }
            onClose={ closeBannerModal }
            handleSubmit={ (values) => handleBannerSave(values, renderProps) }
            title={ actionInfo.action == modalActions.update ? "Actualizar banner" : "Agregar banner" }
            banner={ actionInfo.banner }
            ctaTitle={ actionInfo.action == modalActions.update ? I18n.t("actions.update") : I18n.t("actions.add") }
            fetchCollectionURL={ collectionUrlWithCountry }
            fetchProductURL={ productUrlWithCountry }
            collectionBaseURL={ collectionBaseUrl }
          />

          <FormPageActions
            onPrimaryAction={ renderProps.handleSubmit }
            deleteURL={ props.destroyURL }
            loading={ renderProps.loading }
            disabled={ !renderProps.isValid }
          />
        </div>
      }
    </PolarisFormProvider>
  )
};

SectionBannersForm.propTypes = propTypes;
SectionBannersForm.defaultProps = defaultProps;

export default SectionBannersForm;